export function convert_date_for_ios(date) {
  var arr = date.split(/[- :]/);
  date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
  return date;
}



// WEBPACK FOOTER //
// ./scripts/components/ios.js